import React, { Component } from 'react';
import { GridTable } from '../Sidebar/SidebarStyles';
import { Box, Typography } from '@mui/material';
import BrokerTable from './BrokerTable';
import BrokerActionScreen from './BrokerActionScreen';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { fetchBrokerOptionData, fetchBrokerOptionById } from '../ApiSevices/ExdionAdminApi'

interface State {
    showForm: boolean;
    brokerOption: any[];
    editData: any | null;
    rowData: any | null;
    loading: boolean;
}

interface Props {
    displaysidebar: boolean;
    navigate: Function;
    params: { brokerId?: string };
    location: any;
}

class IntroduceBroker extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            brokerOption: [],
            showForm: false,
            editData: null,
            rowData: null,
            loading: false
        }
    }

    componentDidMount() {
        this.checkAndLoadData();
    }

    componentDidUpdate(prevProps: Props) {
        const prevId = prevProps.params?.brokerId;
        const currentId = this.props.params?.brokerId;

        const prevPath = prevProps.location.pathname;
        const currentPath = this.props.location.pathname;

        if (prevId !== currentId || prevPath !== currentPath) {
            this.checkAndLoadData();
        }
    }

    checkAndLoadData = async () => {
        const { pathname } = this.props.location;
        const { rowData } = this.state;
        const brokerId = this.props.params?.brokerId;

        try {
            this.setState({ editData: null, rowData: null });

            if (pathname.includes('/edit') && brokerId) {
                const fetchResponse = await fetchBrokerOptionById(brokerId);
                if (fetchResponse && fetchResponse.length > 0) {
                    this.setState({ editData: fetchResponse[0] });
                }
            } else if (pathname.includes('/add')) {
                const fetchResponse = await fetchBrokerOptionById(rowData?.BrokerID);
                if (fetchResponse && fetchResponse.length > 0) {
                    this.setState({ editData: fetchResponse[0] });
                }
            } else {
                const fetchResponse = await fetchBrokerOptionData();
                if (fetchResponse && fetchResponse.length > 0) {
                    this.setState({ brokerOption: fetchResponse });
                }
            }
        } catch (error) {
            console.error('Error in checkAndLoadDataAsync:', error);
        }
    };

    fetchBrokerData = async (brokerId?: string | number) => {
        this.setState({ loading: true });

        try {
            const fetchResponse = await fetchBrokerOptionData(brokerId);
            if (fetchResponse && fetchResponse?.length > 0) {
                this.setState({ brokerOption: fetchResponse });
            }

        } catch (error) {
            console.error('Error fetching brokerData:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleAdd = (selectedRow?: any ) => {
        this.setState({ showForm: true, editData: null, rowData: selectedRow }, () => {
            this.props.navigate('/policyCheck/introducebroker/add');
        });
    };

    handleEdit = (data: any) => {
        if (data?.BrokerID) {
            this.setState({ showForm: true, editData: null, rowData: null }, () => {
                this.props.navigate(`/policyCheck/introducebroker/edit/${data.BrokerID}`);
            });
        }
    };

    handleCancel = () => {
        this.setState({ showForm: false, editData: null, rowData: null });
        this.props.navigate('/policyCheck/introducebroker');
    };


    render() {
        const { showForm, editData, brokerOption } = this.state;
        const { displaysidebar } = this.props;
        const path = this.props.location.pathname;
        const isAddOrEdit = path.includes('/introducebroker/add') || path.includes('/introducebroker/edit');

        return (
            <>
                <GridTable displaysidebar={displaysidebar}>
                    <Box sx={{ padding: '2px 0', backgroundColor: '#f8f8f8', borderBottom: '1px solid #ddd', marginBottom: '25px' }}>
                        <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#000', marginLeft: '8px', textTransform: 'uppercase' }}>
                            {showForm ? 'INTRODUCE BROKER' : 'INTRODUCE BROKER'} </span>
                    </Box>

                    <Box >
                        {!isAddOrEdit ? (
                            <BrokerTable onAdd={this.handleAdd} onEdit={this.handleEdit} brokerOption={brokerOption} />
                        ) : (
                            <Box sx={{
                                overflowY: 'auto',
                                maxHeight: '70vh',
                                paddingRight: '8px'
                            }}>
                                {editData ? (
                                    <BrokerActionScreen onCancel={this.handleCancel} editData={editData} />
                                ) : (
                                    <Typography sx={{ fontSize: '13px', color: '#888', textAlign: 'center', mt: 20 }}>
                                        Loading broker details...
                                    </Typography>
                                )}

                            </Box>
                        )}
                    </Box>
                </GridTable>
            </>
        )
    }
};

export default IntroduceBroker;